// Project imports
import config from "../index";
// Action - state management
import * as actionTypes from "./actions";

// First, let's define the state interface
export interface CustomizationState {
    isOpen: string[];
    fontFamily: string;
    borderRadius: number;
    outlinedFilled: boolean;
    navType: string;
    presetColor: string;
    locale: string | undefined;
    opened: boolean;
    showMenuToggle: boolean;
}

type CustomizationAction =
    | { type: typeof actionTypes.MENU_OPEN; id: string }
    | { type: typeof actionTypes.MENU_TYPE; navType: string }
    | { type: typeof actionTypes.PRESET_COLORS; presetColor: string }
    | { type: typeof actionTypes.THEME_LOCALE; locale: string }
    | { type: typeof actionTypes.SET_MENU; opened: boolean }
    | { type: typeof actionTypes.SHOW_MENU_TOGGLE; showMenuToggle: boolean }
    | { type: typeof actionTypes.SET_FONT_FAMILY; fontFamily: string }
    | { type: typeof actionTypes.SET_BORDER_RADIUS; borderRadius: number }
    | { type: typeof actionTypes.SET_OUTLINED_FILLED; outlinedFilled: boolean };

export const initialState: CustomizationState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    outlinedFilled: config.outlinedFilled,
    navType: config.theme,
    presetColor: config.presetColor,
    locale: config.i18n,
    opened: false,
    showMenuToggle: true
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (
    state: CustomizationState = initialState,
    action: CustomizationAction
): CustomizationState => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.MENU_TYPE:
            return {
                ...state,
                navType: action.navType
            };
        case actionTypes.PRESET_COLORS:
            return {
                ...state,
                presetColor: action.presetColor
            };
        case actionTypes.THEME_LOCALE:
            return {
                ...state,
                locale: action.locale
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SHOW_MENU_TOGGLE:
            return {
                ...state,
                showMenuToggle: action.showMenuToggle
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_OUTLINED_FILLED:
            return {
                ...state,
                outlinedFilled: action.outlinedFilled
            };

        default:
            return state;
    }
};

export default customizationReducer;
